import React, { useEffect } from "react";
import useStyles from "../common/Styles";
import { Box } from "@material-ui/core";
import ChartTitle from "../common/ChartTitle";
import AgricultureMap from "./AgricultureMap";
import AgricultureDonut from "./AgricultureDonut";
import AgricultureDeliveries from "./AgricultureDeliveries";
import userActions from '../common/actions';
import appActions from '../../../app/actions';

const ChartView = (props) => {
  const classes = useStyles();
  const { setWaterUserChart } = userActions();
  const { chart } = props;
  const { setChartDrawerStateToClose } = appActions();

  const resetChart = () => {
    return () => setWaterUserChart(0);
  }
  useEffect(resetChart, []);

  return (
    <Box className={classes.chartView} onClick={()=>{ setChartDrawerStateToClose() }}>
      <ChartTitle
        floating={chart.floating_title}
        title={chart.title}
        subtitle={chart.subtitle}
        background={chart.floating_title ? "#EDEDED" : "transparent"}
      />
      {
        {
          title_map: <AgricultureMap />,
          district_water_user: <AgricultureDonut />,
          irrigation_district_water_deliveries: <AgricultureDeliveries />,
        }[chart.id]
      }
    </Box>
  );
};

export default ChartView;
